module.exports = {
  personal: [
    {
      imageURL: 'https://avatars.githubusercontent.com/u/18745378?v=4',
      score: 11.322,
      gamertag: 'pleiterson',
      profile: 'https://account.xbox.com/pt-br/profile?gamertag=pleiterson',
      name: 'Pleiterson Amorim',
      followers: 40,
      friends: 103,
      location: 'Belo Horizonte, Brazil',
      description: 'Apaixonado por games, livros, quadrinhos, bikes, animes, filmes e uma boa birita! // Love with games, books, comics, bikes, anime, movies and a good beer!'
    },
  ],

  personalHC: [
    {
      imageURL: 'https://avatars.githubusercontent.com/u/67475936?v=4',
      score: 2.167,
      gamertag: 'UzumakiDark6558',
      profile: 'https://account.xbox.com/pt-br/profile?gamertag=UzumakiDark6558',
      name: 'Hugo Costa',
      followers: 1,
      friends: 19,
      location: 'Belo Horizonte, Brazil',
      description: 'Gosto de jogar Free Fire, Ark Survival Evolved, Roblox e Minecraft. Free Fire ID:1726074793 // I enjoy playing Free Fire, Ark Survival Evolved, Roblox and Minecraft. Free Fire ID:1726074793'
    },
  ],

  socialMedia: [
    {
      name: 'Twitter',
      url: 'https://twitter.com/pleiterson'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/pleiterson/'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/user/pleiterson'
    },
  ],

  socialMediaHC: [
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/hugocostas2007/'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/channel/UC-DzZw0cghPAuHesGJuS2bg'
    },
  ],

  lastAchievements: [
    {
      date:'14/08/2021',
      imageProfile: 'https://avatars.githubusercontent.com/u/18745378?v=4',
      gamertag: 'pleiterson',
      imageAchievements: 'https://imgur.com/xY6qaMe.png',
      title: 'Maximum Survivor - ARK: Survival Evolved',
      score: 50,
      achievement: 'Maximum Survivor'
    },
    {
      date:'01/08/2021',
      imageProfile: 'https://avatars.githubusercontent.com/u/18745378?v=4',
      gamertag: 'pleiterson',
      imageAchievements: 'https://imgur.com/DcoM1uc.png',
      title: 'Your first ride... - ARK: Survival Evolved',
      score: 20,
      achievement: 'Your first ride...'
    },
    {
      date:'11/07/2021',
      imageProfile: 'https://avatars.githubusercontent.com/u/67475936?v=4',
      gamertag: 'UzumakiDark6558',
      imageAchievements: 'https://imgur.com/rVPvU4S.png',
      title: 'Amigo necessitado - Call of Duty®: WWII',
      score: 25,
      achievement: 'Amigo necessitado'
    },
    {
      date:'27/06/2021',
      imageProfile: 'https://avatars.githubusercontent.com/u/18745378?v=4',
      gamertag: 'pleiterson',
      imageAchievements: 'https://imgur.com/OtKG4zD.png',
      title: 'Bem longe do Texas - Call of Duty®: WWII',
      score: 15,
      achievement: 'Bem longe do Texas'
    },
    {
      date:'05/06/2021',
      imageProfile: 'https://avatars.githubusercontent.com/u/67475936?v=4',
      gamertag: 'UzumakiDark6558',
      imageAchievements: 'https://imgur.com/oYmX6yE.png',
      title: 'Até o Fim - Call of Duty®: WWII',
      score: 50,
      achievement: 'Até o Fim'
    },
  ],
};
